import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Pushes each client-side route to GTM. Trigger on custom event `virtual_page_view` in GTM. */
export default function GtmPageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "spa_pageview",
      page_path: `${location.pathname}${location.search}${location.hash}`,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location]);

  return null;
}
